import { Quote } from "lucide-react";
import type { Testimonial } from "@/types";
import { StarsRating } from "@/components/atoms";

export function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <figure className="flex h-full flex-col gap-4 rounded-card border border-night-blue/10 bg-white p-6">
      <Quote size={28} className="text-leaf-green-ink/40" />
      <blockquote className="flex-1 text-night-blue/80">
        {testimonial.quote}
      </blockquote>
      {testimonial.rating && (
        <StarsRating value={testimonial.rating} size={14} />
      )}
      <figcaption className="text-sm">
        <span className="font-bold text-night-blue">{testimonial.name}</span>
        {testimonial.location && (
          <span className="text-night-blue/70"> · {testimonial.location}</span>
        )}
        {testimonial.condition && (
          <span className="mt-0.5 block text-xs font-medium uppercase tracking-wide text-leaf-green-ink">
            {testimonial.condition}
          </span>
        )}
      </figcaption>
    </figure>
  );
}
